module.exports = __webpack_public_path__ + "img/bg-banner.7965f0d4.jpg";